module.exports = __webpack_public_path__ + "img/Pagsmile_SVITI_Certificate 20221221-1.86278dc.png";